module.exports = __webpack_public_path__ + "img/katarina_kitchen_2.b4511985.jpg";